module.exports = __webpack_public_path__ + "img/develope.32622237.jpg";